import { useContext, useEffect, useMemo, useState } from "react"
import services from "../../../services/services"
import { Urls } from "../../../services/Urls"
import { ToastContext } from "../../../context/ToastContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faStar,
    faHeart,
    faCircleCheck,
    faCircle,
} from '@fortawesome/free-regular-svg-icons';
import _ from "underscore";
import { calculateWordsFromString } from "../../../utils/Helper";
import { callautopopulate } from "../../../services/callautopop";

export const useCreateQuestion = ({ options, setOptions, showPopUp, apiCall, handleClose, questionList, fromSurvey }) => {

    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [formValue, setFormvalue] = useState({
        selection_mode: "s",
        max_level: 2,
        is_allow_past: true,
        is_allow_future: true,
        max_selection: 0,
        create_same_question: false,
        addQuestion: false
    })
    const [choiceOptions, setChoiceOptions] = useState([{ id: 1, option_text: `Option 1`, question_id: 0, order_number: 1, is_active: true }]);

    useEffect(() => {

        if (!_.isEmpty(showPopUp?.data)) {
            setFormvalue({
                ...showPopUp?.data,
                selection_mode: showPopUp?.data?.selection_mode?.trim(),
                rating_symbol: _.find(options?.symbol, { rating_symbol_id: showPopUp?.data?.rating_symbol_id }),
                type: _.find(options?.types, { question_type_id: showPopUp?.data?.question_type_id }),
                category: _.find(options?.category, { question_category_id: showPopUp?.data?.question_category_id })
            })
            if (showPopUp?.data?.option_texts) {
                const optionTexts = showPopUp?.data?.option_texts.split(',').map(text => text.trim());
                const orderNumbers = showPopUp?.data?.order_numbers.split(',').map(num => parseInt(num.trim()));
                const newChoiceOptions = optionTexts.map((text, index) => ({
                    id: index + 1,
                    option_text: text || `Option ${index + 1}`,
                    question_id: showPopUp?.data?.question_id || 0,
                    order_number: orderNumbers[index] || index + 1,
                    is_active: true
                }));

                setChoiceOptions(showPopUp?.data?.option_texts ? _.sortBy(newChoiceOptions, "") : []);
            }
        } else {
            setFormvalue((prev) => ({
                ...prev,
                type: options?.types?.[0],
            }))
        }

    }, [showPopUp?.data])

    const questionTypeConfigs = {
        choice: {
            max_selection: 2,
            min_length: 0,
            max_length: 0,
            regex_pattern: "",
            max_level: 0,
            rating_symbol: 0,
        },
        text: {
            selection_mode: "",
            max_selection: 0,
            regex_pattern: "",
            max_level: 0,
            rating_symbol: 0,
        },
        rating: {
            selection_mode: "",
            max_selection: 0,
            regex_pattern: "",
            min_length: 0,
            max_length: 0,
            max_level: 2,
        },
        date: {
            selection_mode: "",
            max_selection: 0,
            regex_pattern: "",
            min_length: 0,
            max_length: 0,
            rating_symbol: 0,
            max_level: 0,
        },
    };

    const handleOnChange = (e) => {
        const { name, value, checked } = e.target;
        if (name === "category") {
            const getCategoryQuestions = _.find(questionList, { category: value?.question_category_key })?.questions
            setFormvalue((prev) => ({ ...prev, [name]: value, order_number: getCategoryQuestions?.length > 0 ? getCategoryQuestions?.length + 1 : 1, question_category_display_name: value?.question_category_display_name } || ""));
            return;
        }
        if (name === "is_allow_future" || name === "is_allow_past") {
            setFormvalue((prev) => ({ ...prev, [name]: checked }));
            return;
        }
        if (name === "type") {
            const config = questionTypeConfigs[value?.question_type_key];
            if (config) {
                setChoiceOptions([{
                    id: 1,
                    option_text: "Option 1",
                    question_id: 0,
                    order_number: 1,
                    is_active: true
                }]);
                if (!_.isEmpty(showPopUp?.data) && _.isEqual(_.find(options?.types, { question_type_id: showPopUp?.data?.question_type_id }), value)) {
                    setFormvalue({
                        ...showPopUp?.data,
                        selection_mode: showPopUp?.data?.selection_mode?.trim(),
                        rating_symbol: _.find(options?.symbol, { rating_symbol_id: showPopUp?.data?.rating_symbol_id }),
                        type: _.find(options?.types, { question_type_id: showPopUp?.data?.question_type_id }),
                        category: _.find(options?.category, { question_category_id: showPopUp?.data?.question_category_id })
                    })
                } else {
                    setFormvalue((prev) => ({
                        ...prev,
                        ...config,
                        [name]: value,
                        ...(value?.question_type_key === "rating" && { rating_symbol: _.find(options?.symbol, { rating_symbol_key: "star" }) }),
                    }));
                }
            }
            return;
        }
        setFormvalue((prev) => ({ ...prev, [name]: value }));
    };

    const addOption = () => {
        const newId = choiceOptions?.length + 1;
        setChoiceOptions(prev => [...prev, { id: newId, option_text: `Option ${newId}`, question_id: 0, order_number: newId, is_active: true }]);
    };

    const removeOption = (id) => {
        if (choiceOptions.length > 2) {
            setChoiceOptions(prev => prev.filter(option => option.id !== id));
        } else {
            showInfo("Info", "Atleast two options are required for question type choice.");
        }
    };

    const handleOptionChange = (id, value) => {
        setChoiceOptions(prev =>
            prev.map(option =>
                option.id === id ? { ...option, option_text: value } : option
            )
        );
        setFormvalue(prev => ({ ...prev, options: choiceOptions }));
    };

    const handleSave = async () => {
        const getCategoryQuestions = _.find(questionList, { category: formValue?.category?.question_category_key })?.questions
        const existing = _.find(getCategoryQuestions, (que) => que?.question_title?.trim() == formValue?.question_title?.trim())
        if (!formValue?.category || formValue?.category?.question_category_name === 0) {
            showInfo("info", "Please select a section.");
            return;
        }
        if (!formValue?.question_category_display_name) {
            showInfo("info", "Please enter question category display name");
            return
        }
        if (!formValue?.question_title?.trim()) {
            showInfo("Info", "Please enter question title");
            return;
        }
        if (calculateWordsFromString(formValue?.question_title) < 2) {
            showInfo("Info", "Please enter question title of atleast 2 words");
            return;
        }
        if (getCategoryQuestions?.length > 0 && !_.isEmpty(existing) && existing?.question_id !== (formValue?.question_id || 0)) {
            showInfo("Info", "The question title already exists in this category. ");
            return;
        }
        if (!formValue?.type?.question_type_id) {
            showInfo("Info", "Please select question type");
            return;
        }
        if (formValue?.type?.question_type_key === "choice") {
            if (!formValue?.selection_mode) {
                showInfo("Info", "Please select single or multiple choice");
                return;
            }
            if (formValue?.selection_mode === "m" && (formValue?.max_selection < 2 || choiceOptions?.length < formValue?.max_selection)) {
                showInfo("Info", "Max selection value must be atleast two & less than option added.")
                return;
            }
            if (choiceOptions.length < 2) {
                showInfo("Info", "Please add atleast two choice option");
                return;
            }
            const emptyOptions = choiceOptions.some(option => !option.option_text?.trim());
            if (emptyOptions) {
                showInfo("Info", "All choice options must have text.");
                return;
            }
        }

        if (formValue?.type?.question_type_key === "text") {
            const minLength = parseInt(formValue?.min_length) || 0;
            const maxLength = parseInt(formValue?.max_length) || 0;

            if (minLength <= 0) {
                showInfo("Info", "Minimum length must be greater than 0");
                return;
            }
            if (minLength >= maxLength) {
                showInfo("Info", "Minimum length cannot be greater than maximum length");
                return;
            }
        }

        if (formValue?.type?.question_type_key === "rating") {
            if (!formValue?.max_level || formValue?.max_level < 2) {
                showInfo("Info", "Rating level must be 2 or higher");
                return;
            }

            if (!formValue?.rating_symbol?.rating_symbol_id) {
                showInfo("Info", "Please select rating symbol");
                return;
            }
        }

        try {
            const category_key = (formValue?.category?.question_category_name || "").replace(/\s+/g, '_')
            const payload = {
                "question_id": formValue?.question_id || 0,
                "question_category_id": formValue?.category?.question_category_id || 0,
                "question_category_key": category_key,
                "question_category_display_name": formValue?.question_category_display_name || "",
                "question_category_name": formValue?.category?.question_category_name || "",
                "question_type_id": formValue?.type?.question_type_id,
                "question_title": formValue?.question_title?.trim(),
                "question_short_title": formValue?.question_short_title?.trim() || "",
                "is_active": true,
                "selection_mode": formValue?.selection_mode,
                "max_selection": formValue?.selection_mode === "m" ? parseInt(formValue?.max_selection) : 0,
                "min_length": parseInt(formValue?.min_length) || 0,
                "order_number": formValue?.order_number ? parseInt(formValue?.order_number) : getCategoryQuestions?.length + 1 || 0,
                "max_length": parseInt(formValue?.max_length) || 0,
                "regex_pattern": formValue.regex_pattern || "",
                "is_allow_past": formValue?.is_allow_past || true,
                "is_allow_future": formValue?.is_allow_future || true,
                "max_level": formValue?.max_level || 0,
                "rating_symbol_id": formValue?.rating_symbol?.rating_symbol_id || 0,
                "survey_question_choice_option": formValue?.type?.question_type_key === "choice" ? choiceOptions : []
            };

            const res = await services.getInvokeRemote("POST", Urls("UPSERTQUESTIONDETAILS"), payload);
            if (res?.body.StatusCode === 400 || res?.body.StatusCode === 204 || res?.body.StatusCode === 202 || res?.body.StatusCode === 401 || res?.body.StatusCode === 500) {
                showError('Error', res?.body.errorMessage);
            } else if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                sessionStorage.removeItem("question_category");
                const categoriesRes = await callautopopulate("question_category");
                const categories = categoriesRes?.question_category || [];
                if (setOptions) {
                    setOptions(prevOptions => ({
                        ...prevOptions,
                        category: _.sortBy(categories, "question_category_name"),
                    }));
                }
                const category = _.find(categories, { "question_category_key": category_key })
                if (formValue?.create_same_question) {
                    setFormvalue((prev) => ({ ...prev, question_title: "", question_short_title:"",category, question_id: 0, order_number: formValue?.order_number ? formValue?.order_number + 1 : 0, addQuestion: true }));
                    return;
                } else {
                    handleClose();
                    apiCall(fromSurvey ? payload?.question_title : null);
                }
            } else {
                showError("Error", res?.body?.message);
            }
        } catch (error) {
             showError("Error", error?.response?.data?.errorMessage);
            console.error(error);
        }
    };

    const getIcon = (symbolKey, index) => {
        const icons = {
            'star': <FontAwesomeIcon icon={faStar} style={{ color: "#bcc1c6", cursor: "auto" }} />,
            'heart': <FontAwesomeIcon icon={faHeart} style={{ color: "#bcc1c6", cursor: "auto" }} />,
            'trophy': <FontAwesomeIcon icon="fa-solid fa-trophy" style={{ color: "#bcc1c6", cursor: "auto" }} />,
            'check': <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#bcc1c6", cursor: "auto" }} />,
            'badge': <FontAwesomeIcon icon={faCircle} style={{ color: "#bcc1c6", cursor: "auto" }} />,
            'number': (
                <>
                    <div className="border px-2">{index + 1}</div>
                </>
            )
        };
        return icons[symbolKey] || <FontAwesomeIcon icon={faStar} style={{ color: "#bcc1c6", cursor: "auto" }} />;
    };


    return useMemo(() => ({
        handleOnChange, formValue, setFormvalue, addOption, removeOption, choiceOptions, handleOptionChange, handleSave, getIcon, showInfo
    }), [handleOnChange, formValue, setFormvalue, addOption, removeOption, choiceOptions, handleOptionChange, handleSave, getIcon, showInfo])
}